module.exports = __webpack_public_path__ + "static/img/icon-cate-age.d7a677a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head/icon-cate-age.png
// module id = UbW6
// module chunks = 1